// LIBRARIES //
import React, { useCallback, Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

// COMPONENTS //
import NoticeCardList from './CardLists/NoticeCardList';
import { ALL_NOTICES } from './TenantActivity';

// ACTIONS //
import { getResidentNotices } from './store/actions';

// HELPERS //
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

const ActivityTitle = styled.p`
  font-size: 24px;
  font-weight: bold;
  color: ${colors.DARK_GRAY};
  padding-bottom: 20px;
  margin: 0;
`;

const ActivityEmptyText = styled.p`
  font-size: 16px;
  color: ${colors.MED_DARK_GRAY};
  padding-bottom: 24px;
  margin: 0;
`;

const StyledViewAll = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: ${colors.DEEP_BLUE};
  padding-bottom: 24px;
  margin: 0;
  text-align: center;
  cursor: pointer;
`;

const NoticeList = ({
  cotenantId,
  getResidentNotices,
  residentNotices,
  totalResidentNotices,
  setView,
  propertyId,
  leaseId,
}) => {
  const handleClickViewAll = useCallback(
    () => {
      getResidentNotices(cotenantId, propertyId, 'all');
      setView(ALL_NOTICES);
    },
    [cotenantId, getResidentNotices, setView, propertyId]
  );

  return (
    <Fragment>
      <ActivityTitle>
        {getTranslatedString('landlordPortal.tenantDetails.activity.noticesNoCount')}
      </ActivityTitle>
      {residentNotices.length > 0 ? (
        <Fragment>
          <NoticeCardList notices={residentNotices} propertyId={propertyId} leaseId={leaseId} />
          <StyledViewAll onClick={handleClickViewAll}>
            {getTranslatedString('landlordPortal.tenantDetails.activity.viewAll', {
              totalCount: totalResidentNotices,
            })}
          </StyledViewAll>
        </Fragment>
      ) : (
        <ActivityEmptyText>
          {getTranslatedString('landlordPortal.tenantDetails.activity.noticesEmpty')}
        </ActivityEmptyText>
      )}
    </Fragment>
  );
};

const mapStoreToProps = store => ({
  cotenantId: store.landlordTenants.tenantDetails.id,
  propertyId: store.landlordTenants.tenantDetails.lease.property_id,
  leaseId: store.landlordTenants.tenantDetails.lease.id,
  residentNotices: store.landlord.tenants.tenantActivity.residentNotices,
  totalResidentNotices: store.landlord.tenants.tenantActivity.totalResidentNotices,
});

const mapDispatchToProps = {
  getResidentNotices,
};

export default connect(mapStoreToProps, mapDispatchToProps)(NoticeList);
